module.exports = "<slot name=\"logo\"><lui-logo></lui-logo></slot>\n<span class=\"lui-productname__text\"><span><slot></slot></span></span>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-logo/theme/lui-productlogo.html
// module id = 239
// module chunks = 0 1 10